import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CustomLoader from "../../../../../Components/CustomLoader";
import ErrorMessage from "../../../../../Components/ErrorMessage";
import EliminarTipo from "./EliminarTipo";
import NuevoTipoC from "../Actions/NuevoTipoC";
import { useTheme } from "@mui/material";
import { getBicolorTable } from "../../../../../Config/reuserFunctions";

export default function TiposContactoTable({ tiposCQuery }) {
  const { loading, data, error, refetch } = tiposCQuery;
  const theme = useTheme();

  if (loading) return <CustomLoader />;
  if (error) return <ErrorMessage />;

  return (
    <Paper variant="outlined" sx={{ overflow: "hidden" }}>
      <TableContainer
        sx={{
          height: { xs: `calc(100vh - 232px)`, sm: `calc(100vh - 124px)` },
          flex: 1,
          overflowX: "auto",
        }}
      >
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>Tipo contacto</TableCell>
              <TableCell padding="checkbox" />
              <TableCell padding="checkbox" />
            </TableRow>
          </TableHead>
          <TableBody>
            {data.obtenerTipoContactos.map((data, index) => {
              return (
                <TableRow
                  role="checkbox"
                  tabIndex={-1}
                  key={`tipoContact-${data._id}`}
                  style={getBicolorTable(theme, index)}
                  sx={{ minWidth: "48px" }}
                >
                  <TableCell>{data.tipoContacto}</TableCell>
                  <TableCell padding="checkbox">
                    <NuevoTipoC edit={true} data={data} refetch={refetch} />
                  </TableCell>
                  <TableCell padding="checkbox">
                    <EliminarTipo data={data} refetch={refetch} />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
